import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        selectedLanguage: '=',
        formSubmission: '='
    },
    template: `
        <select
            ng-change="vm.changeLanguage()"
            ng-model="vm.selectedLanguage"
            class="form-control">
            <option ng-repeat="language in vm.TokenService.getCompanySupportedLanguages()" value="{{ language }}">
                {{ vm.COMPANY_LANGUAGE_ENUM.DROPDOWN_LABELS_IN_NATIVE[language] }}
            </option>
        </select>
    `
})
export default class {
    constructor ($rootScope, TokenService, COMPANY_LANGUAGE_ENUM, FormService) {
        this.$rootScope = $rootScope;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.TokenService = TokenService;
        this.FormService = FormService;
    }

    $onInit () {
        this.isEvaluationForm = this.FormService.isEvaluationForm(this.formSubmission.form);
        this.isSurveyForm = this.FormService.isSurveyForm(this.formSubmission.form);
        this.isCertificationFeedbackForm = this.FormService.isCertificationFeedbackForm(this.formSubmission.form);
    }

    changeLanguage () {
        if (this.isEvaluationForm) {
            this.$rootScope.$emit('evaluation:language', this.selectedLanguage);
        }
        if (this.isSurveyForm) {
            this.$rootScope.$emit('survey:language', this.selectedLanguage);
        }
        if (this.isCertificationFeedbackForm) {
            this.$rootScope.$emit('cert-feedback:language', this.selectedLanguage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/language/switcher/index.js